import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { SiteGate } from "@/components/gate/SiteGate";
import Home from "@/pages/Home";
import OrdoPage from "@/pages/Ordo";
import InfrastructurePage from "@/pages/Infrastructure";
import CapabilityPage from "@/pages/CapabilityPage";
import EnterprisePage from "@/pages/Enterprise";
import DiagnosticPage from "@/pages/Diagnostic";
import SoftwarePage from "@/pages/Software";
import ResearchPage from "@/pages/Research";
import BriefcasePage from "@/pages/Briefcase";
import FormaPage from "@/pages/Forma";
import LumenPage from "@/pages/Lumen";
import EngagePage from "@/pages/Engage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteGate>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="ordo" element={<OrdoPage />} />
            <Route path="ordo/infrastructure" element={<InfrastructurePage />} />
            <Route path="ordo/engine" element={<CapabilityPage id="engine" />} />
            <Route path="ordo/stewardship" element={<CapabilityPage id="stewardship" />} />
            <Route path="enterprise" element={<EnterprisePage />} />
            <Route path="enterprise/diagnostic" element={<DiagnosticPage />} />
            <Route path="enterprise/software" element={<SoftwarePage />} />
            <Route path="enterprise/breakpoint" element={<CapabilityPage id="breakpoint" />} />
            <Route path="enterprise/mesh" element={<CapabilityPage id="mesh" />} />
            <Route path="research" element={<ResearchPage />} />
            <Route path="products/briefcase" element={<BriefcasePage />} />
            <Route path="products/forma" element={<FormaPage />} />
            <Route path="products/lumen" element={<LumenPage />} />
            <Route path="engage" element={<EngagePage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        </SiteGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
